// vue babel plugin doesn't support pragma replacement
import { mdx } from '@mdx-js/vue'
let h;
/* @jsx mdx */

export const metadata = {
  title: "Simple Math Operations",
  author: {
    name: "Damian Kaminski",
    githubUsername: "damian996"
  },
  created: "2020-07-06T14:00:00Z",
  timeLimit: 45,
  introduction: "This room focuses on math... There are 3 coding puzzles to solve. To escape you will need to solve all of them and enter the solution in a following format: \n\nXXXX-YYYY-ZZZZ where XXXX is solution of task 1, YYYY is solution of task 2 and ZZZZ is solution of task 3.",
  finalAnswer: "3264-6546-504"
};

const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`Tasks`}</h1>
    <h2>{`Task 1`}</h2>
    <p>{`Reverse Polish Notation (RPN) is a mathematical notation in which operators follow their operands, for instance, to add 3 and 4, you would write 3 4 + rather than 3 + 4. If there are multiple operations, operators are given immediately after their second operands; so the expression written 3 − 4 + 5 in conventional notation would be written as 3 4 − 5 + in Reverse Polish Notation (4 is first subtracted from 3, then 5 is added to it). An advantage of reverse Polish notation is that it removes the need for parentheses that are required by infix notation, for example 2 x (3 + 4) in RPN will be written as 2 3 4 + x. `}</p>
    <p>{`Your task is to calculate the following expression: 4 2 4 8 `}<em parentName="p">{` + 9 8 `}</em>{` 3 / * * `}</p>
    <h2>{`Task 2`}</h2>
    <p>{`This task is very simple. You just need to add three numbers. The only difficulty is that numbers are written in Roman numerals and the result should be translated to arabic numerals (0, 1, 2, 3, 4, 5, 6, 7, 8 and 9). `}</p>
    <p>{`Expression to calculate is MMMDCCXXIV + MMCXLVII + DCLXXV`}</p>
    <h2>{`Task 3`}</h2>
    <p>{`The least common denominator (LCD) is the smallest number that can be a common denominator for a set of fractions. Also known as the lowest common denominator, it is the lowest number you can use in the denominator to create a set of equivalent fractions that all have the same denominator. `}</p>
    <p>{`Find the LCD of 1/2, 6/8, 5/7, 7/9, 1/3`}</p>
    <h1>{`Final Puzzle`}</h1>
    <p>{`Please enter your combined solution from task 1, task 2 and task 3`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export default {
  name: 'Mdx',
  inject: {
    $mdxComponents: {
      default: () => () => ({})
    }
  },
  computed: {
    components() {
      return this.$mdxComponents()
    }
  },
  render(createElement) {
    h = mdx.bind({ createElement, components: this.components })
    return MDXContent({ components: this.components })
  }
}
   